import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import invariant from 'invariant';
import _mapValues from 'lodash/mapValues';
import _omit from 'lodash/omit';
import { getReduxMountPoint, REDUX_MOUNT_POINT } from './mountPoint';
import { updateAndValidate } from '../actions';
/**
 * Helper function for providing props to redux-input controlled components
 * @param inputConfig
 * @param state - redux-inputs form state
 * @param dispatcher
 */

export default (function (inputConfig, inputsState, dispatch) {
  return _mapValues(_omit(inputConfig, REDUX_MOUNT_POINT), function (config, id) {
    var inputState = inputsState[id];
    invariant(inputState, "[redux-inputs]: ".concat(id, " not found in state. Make sure to configure your redux-input reducer."));

    var value = inputState.value,
        error = inputState.error,
        otherState = _objectWithoutProperties(inputState, ["value", "error"]);

    var hasError = typeof error !== 'undefined';
    return _objectSpread({
      _id: [getReduxMountPoint(inputConfig), id].join('-'),
      value: hasError ? error : value,
      error: hasError,
      // Prebound change callback
      dispatchChange: function dispatchChange(newVal) {
        return dispatch(updateAndValidate(inputConfig, _defineProperty({}, id, newVal)));
      }
    }, config.props, {}, otherState);
  });
});